import { combineReducers } from 'redux';
import auth from './auth';
import user from './user';
import results from './results';
import setup from './setup';
import step from './step';
import currentWindow from './current-window-index';
import appView from './app-view';
import modal from './modal';
import imageZoomPopup from './image-zoom-popup';
import fleetParade from './fleet-parade';
import language from './language';
import report from './report';

import * as AuthActionTypes from '../actions/auth.js';

const appReducer = combineReducers({
	auth,
	user,
	results,
	setup,
	step,
	appView,
	currentWindow,
	modal,
	imageZoomPopup,
	fleetParade,
	language,
	report
});

const rootReducer = (state, action) => {
	switch (action.type) {

		case AuthActionTypes.LOGOUT_SUCCESS:
		case AuthActionTypes.LOGOUT_FAILED:

		    // todo: this can be implemented in future, but requires a little more effort with state management
			// clear everything, except auth and report
			// to make logged out checks and report redirect possible after logout
			// state = {
			// 	report: {
			// 		...state.report
			// 	}
			// };

		    break;

		default:
			break
	}
	return appReducer(state, action)
};

export default rootReducer;
